export default __webpack_public_path__ + "static/media/BG-Green-0000.8169660a.png";